import styled from 'styled-components';

import { visuallyHiddenCss } from 'components/VisuallyHidden';
import { colors, transition } from 'theme';

export const TabSwitcherTabInput = styled.input`
  ${visuallyHiddenCss}

  &:checked + label {
    color: ${colors.waterBlue};
  }
`;

export const TabSwitcherTabLabel = styled.label`
  user-select: none;
  display: inline-block;
  padding: 16px;
  background: none;
  border: none;
  cursor: pointer;
  transition: ${transition};
  position: relative;

  color: ${colors.battleshipGrey};

  &:before {
    content: '';
    position: absolute;
    height: 2px;
    transition: ${transition};
    transform: translateX(-50%);
    left: 50%;
    bottom: 0;
    width: 75%;
    opacity: 0;
  }

  &:hover:before {
    background: ${colors.battleshipGrey};
    width: 100%;
    opacity: 0.3;
  }
`;
